import { useState } from "react";
import { useTranslation } from "react-i18next";
import { base44 } from "@/api/base44Client";

const emptyPhotos = () => ({ frente: null, perfil_esq: null, perfil_dir: null });
export const photoUrls = (photos) => Object.values(photos).filter(Boolean);

export const usePhotoAnalysis = () => {
  const { t, i18n } = useTranslation();
  const [analysisType, setAnalysisType] = useState(null);
  const [before, setBefore] = useState(emptyPhotos);
  const [after, setAfter] = useState(emptyPhotos);
  const [uploading, setUploading] = useState(null);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");
  const [warning, setWarning] = useState("");
  const selectPhoto = async (file, prefix, angle) => {
    setUploading(`${prefix}-${angle}`); setError("");
    try {
      const { file_url } = await base44.integrations.Core.UploadFile({ file });
      (prefix === "before" ? setBefore : setAfter)((previous) => ({ ...previous, [angle]: file_url }));
    } catch (failure) { setError(failure.message); } finally { setUploading(null); }
  };
  const removePhoto = (prefix, angle) => (prefix === "before" ? setBefore : setAfter)((previous) => ({ ...previous, [angle]: null }));
  const analyze = async () => {
    const photosBefore = photoUrls(before), photosAfter = photoUrls(after);
    if (!photosBefore.length || !photosAfter.length || uploading || loading) return;
    setWarning(photosBefore.length !== photosAfter.length ? t("photoAnalysis.warning", { before: photosBefore.length, after: photosAfter.length }) : "");
    setLoading(true); setError("");
    try {
      const response = await base44.functions.invoke("analyzePhotos", { analysisType, photosBefore, photosAfter, language: i18n.language?.split("-")[0] || "pt" });
      setReport(response.data.report);
    } catch (failure) { setError(failure.message); } finally { setLoading(false); }
  };
  const reset = () => { setAnalysisType(null); setBefore(emptyPhotos()); setAfter(emptyPhotos()); setReport(null); setError(""); setWarning(""); };
  return { analysisType, setAnalysisType, before, after, uploading, loading, report, error, setError, warning, selectPhoto, removePhoto, analyze, reset };
};